"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEditSection = void 0;
const React = require("react");
const react_1 = require("react");
const TSalesOrderItemType_1 = require("../../../types/TSalesOrderItemType");
const EditProductButton_1 = require("../EditProductButton");
const useIsDeliveryItem_1 = require("../../../hooks/useIsDeliveryItem");
const useIsServiceItem_1 = require("../../../hooks/useIsServiceItem");
const useConfig_1 = require("../../../../../../hooks/useConfig");
const RemoveProductButton_1 = require("../RemoveProductButton");
const ChangeProductQuantity_1 = require("../../ChangeProductQuantity");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductEditSection");
const ProductEditSection = ({ salesOrderItem, removeSalesOrderItemFromSalesOrder, isUpdatingCart, updateProductQuantity, index, builderPromise, setSalesOrderItemBuiltDetails }) => {
    const { deliveryId, serviceId } = (0, useConfig_1.useConfig)();
    // only normal products can have their quantity changed
    const isDeliveryItem = (0, useIsDeliveryItem_1.useIsDeliveryItem)(salesOrderItem, deliveryId);
    const isServiceItem = (0, useIsServiceItem_1.useIsServiceItem)(salesOrderItem, serviceId);
    const canRemove = (0, react_1.useMemo)(() => !isDeliveryItem && !isServiceItem, [
        isDeliveryItem,
        isServiceItem
    ]);
    // function to update a product's quantity
    const changeProductQuantity = (0, react_1.useCallback)((newQuantity) => {
        if (salesOrderItem) {
            // if not a number because we use text input then convert it
            if (typeof newQuantity !== "number") {
                newQuantity = Number(newQuantity);
            }
            // update product quantity with new value
            updateProductQuantity(salesOrderItem, newQuantity, index)
                .then(() => builderPromise.current.resolve(true))
                .catch(() => builderPromise.current.reject(false));
        }
        else {
            builderPromise.current.resolve(false);
        }
        setSalesOrderItemBuiltDetails(null);
    }, [salesOrderItem]);
    return (React.createElement("div", { className: css("") },
        canRemove && (React.createElement(RemoveProductButton_1.RemoveProductButton, { salesOrderItem: salesOrderItem, removeSalesOrderItemFromSalesOrder: removeSalesOrderItemFromSalesOrder, isUpdatingCart: isUpdatingCart })),
        salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Built && (React.createElement(EditProductButton_1.EditProductButton, { salesOrderItem: salesOrderItem, index: index, setSalesOrderItemBuiltDetails: setSalesOrderItemBuiltDetails })),
        (!isDeliveryItem || !isServiceItem) && (React.createElement("div", { className: css("changeProductQty") },
            React.createElement(ChangeProductQuantity_1.ChangeProductQuantity, { salesOrderItem: salesOrderItem, onInputChange: changeProductQuantity })))));
};
exports.ProductEditSection = ProductEditSection;
//# sourceMappingURL=index.js.map